export const init = () => {

  // TRACKER 'BASKET'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.funnel.express);
  const sep = AnalyticsConstants.separator;
  const fwk = CUBE.Analytics;

  const productNature = '%PRODUCT_NATURE%'; // tc_vars.product_nature;
  const productName = tc_vars.product_label_displayed;
  const productId = tc_vars.product_id_model;

  const returnLabel = () => productName + sep + fwk.utils.productpage.getSelectedModelId();
  const returnValue = () => fwk.utils.productpage.getSelectedQuantity() * fwk.utils.productpage.getSelectedPrice();

  const commonEvent = (commonGetters) => {
    const cEvent = new AnalyticsClickEvent('event', tracker.defaultEvent());
    cEvent.domContainer = '#modal-express-payment-layout';
    if ((typeof commonGetters === 'undefined') || commonGetters) {
      cEvent.getLabel = returnLabel;
      cEvent.getValue = returnValue;
    }
    return cEvent;
  };

  //tracker.addEvent(event);

  // "Make Your Choice" screen
  const expressCheckout = commonEvent();
  expressCheckout.name = 'expressCheckout';
  delete expressCheckout.domContainer;
  expressCheckout.domElement = '#express-payment-cta';
  expressCheckout.getAction = () => {
    if ($('.product-display .sizes__size--selected .sizes__info').length > 0)
      return 'Express Payment';
    return 'AlertExpressNoSizeSelected';
  };
  tracker.addEvent(expressCheckout);


  // "Login" screen
  const expressCheckoutLogin = commonEvent();
  expressCheckoutLogin.name = 'expressCheckoutLogin';
  expressCheckoutLogin.domElement = '#loginForm .m-login-panel-footer button.cta';
  expressCheckoutLogin.options.action = 'Login';
  tracker.addEvent(expressCheckoutLogin);


  // "Summary" screen
  const expressCheckoutModifyShipping = commonEvent();
  expressCheckoutModifyShipping.name = 'expressCheckoutModifyShipping';
  expressCheckoutModifyShipping.domElement = '#express-checkout-shipping-method-modify-btn';
  expressCheckoutModifyShipping.options.action = 'Summary Modify Shipping';
  tracker.addEvent(expressCheckoutModifyShipping);

  const expressCheckoutModifyPayment = commonEvent();
  expressCheckoutModifyPayment.name = 'expressCheckoutModifyPayment';
  expressCheckoutModifyPayment.domElement = '#express-checkout-payment-method-modify-btn';
  expressCheckoutModifyPayment.options.action = 'Summary Modify Payment';
  tracker.addEvent(expressCheckoutModifyPayment);

  const expressCheckoutOtherOptions = commonEvent();
  expressCheckoutOtherOptions.name = 'expressCheckoutOtherOptions';
  expressCheckoutOtherOptions.domElement = '#pay-order-btn-other';
  expressCheckoutOtherOptions.options.action = 'Summary Other options';
  tracker.addEvent(expressCheckoutOtherOptions);

  const expressCheckoutOrderPay = commonEvent();
  expressCheckoutOrderPay.name = 'expressCheckoutOrderPay';
  expressCheckoutOrderPay.domElement = '#pay-order-btn-xpress';
  expressCheckoutOrderPay.options.action = 'Summary Order & Pay';
  tracker.addEvent(expressCheckoutOrderPay);


  // "Shipping" modify screen
  const expressCheckoutShippingConfirm = commonEvent();
  expressCheckoutShippingConfirm.name = 'expressCheckoutShippingConfirm';
  expressCheckoutShippingConfirm.domElement = '#express-shipping-content #validate-shipping';
  expressCheckoutShippingConfirm.options.action = 'Shipping Confirm';
  tracker.addEvent(expressCheckoutShippingConfirm);

  const expressCheckoutShippingCancel = commonEvent();
  expressCheckoutShippingCancel.name = 'expressCheckoutShippingCancel';
  expressCheckoutShippingCancel.domElement = '#express-shipping-content #cancel-shipping, #express-shipping-content .bullet.nav-step.prev-step';
  expressCheckoutShippingCancel.options.action = 'Shipping Cancel';
  tracker.addEvent(expressCheckoutShippingCancel);

  const expressCheckoutShippingSelectShipping = commonEvent();
  expressCheckoutShippingSelectShipping.name = 'expressCheckoutShippingSelectShipping';
  expressCheckoutShippingSelectShipping.domElement = '.shipping-method .method-option > .radio > label';
  expressCheckoutShippingSelectShipping.getAction = ($element) => `Shipping Select ${  sep  } ${  $element.find('.indicator span').text().trim()}`;
  tracker.addEvent(expressCheckoutShippingSelectShipping);

  const expressCheckoutShippingSelectAddress = commonEvent();
  expressCheckoutShippingSelectAddress.trigger = 'change';
  expressCheckoutShippingSelectAddress.name = 'expressCheckoutShippingSelectAddress';
  expressCheckoutShippingSelectAddress.domElement = '#addressbook_picker';
  expressCheckoutShippingSelectAddress.getAction = ($element) => `Shipping Change Address ${  sep  } Position-${  $element[0].selectedIndex + 1}`;
  tracker.addEvent(expressCheckoutShippingSelectAddress);

  const expressCheckoutShippingSelectCarrier = commonEvent();
  expressCheckoutShippingSelectCarrier.name = 'expressCheckoutShippingSelectCarrier';
  expressCheckoutShippingSelectCarrier.domElement = '#shipping-home-delivery-container .shipping-block > .radio > label';
  expressCheckoutShippingSelectCarrier.getAction = ($element) => `Shipping Change Carrier ${  sep  } ${  $element.find('input.radio-input').attr('id').toUpperCase()}`;
  tracker.addEvent(expressCheckoutShippingSelectCarrier);


  // "Payment" modify screen
  const expressCheckoutPaymentChange = commonEvent();
  expressCheckoutPaymentChange.name = 'expressCheckoutPaymentChange';
  expressCheckoutPaymentChange.domElement = '#express-payment-content .method-option';
  expressCheckoutPaymentChange.getAction = ($element) => `Payment Select ${  sep  } ${  $element.find('.indicator').text().trim()}`;
  tracker.addEvent(expressCheckoutPaymentChange);

  const expressCheckoutPaymentCancel = commonEvent();
  expressCheckoutPaymentCancel.name = 'expressCheckoutPaymentCancel';
  expressCheckoutPaymentCancel.domElement = '#express-payment-content #cancel-payment, #express-payment-content .bullet.nav-step.prev-step';
  expressCheckoutPaymentCancel.options.action = 'Payment Cancel';
  tracker.addEvent(expressCheckoutPaymentCancel);

  const expressCheckoutPaymentConfirm = commonEvent();
  expressCheckoutPaymentConfirm.name = 'expressCheckoutPaymentConfirm';
  expressCheckoutPaymentConfirm.domElement = '#express-payment-content #validate-payment';
  expressCheckoutPaymentConfirm.options.action = 'Payment Confirm';
  tracker.addEvent(expressCheckoutPaymentConfirm);


  /*
	 * "Empty Events" > Executes code trough function 'triggerVirtual' (for Virtual Page)
	 * 	then returns 'true' to 'stepEvent()'
	 */

  // VIRTUAL PAGE - LOGIN
  const expressCheckoutVirtualLogin = new AnalyticsEvent('expressCheckoutVirtualLogin', tracker.defaultEvent());
  tracker.addEvent(expressCheckoutVirtualLogin);

  const expressCheckoutVirtualMissingInformation = new AnalyticsEvent('expressCheckoutVirtualMissingInformation', tracker.defaultEvent());
  tracker.addEvent(expressCheckoutVirtualMissingInformation);

  const expressCheckoutVirtualSummary = new AnalyticsEvent('expressCheckoutVirtualSummary', tracker.defaultEvent());
  tracker.addEvent(expressCheckoutVirtualSummary);

  // VIRTUAL PAGE - SHIPPING
  const expressCheckoutVirtualShipping = new AnalyticsEvent('expressCheckoutVirtualShipping', tracker.defaultEvent());
  tracker.addEvent(expressCheckoutVirtualShipping);

  // VIRTUAL PAGE - PAYMENT
  const expressCheckoutVirtualPayment = new AnalyticsEvent('expressCheckoutVirtualPayment', tracker.defaultEvent());
  tracker.addEvent(expressCheckoutVirtualPayment);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/funnel/express-checkout-tracker.js